import dialogType from '../../../../display/dialogs/dialogType'

import Word  from '../../../../things/Word'

import api from '../../../../configs/api'

const activities =
{
    title : 'Activités' ,
    edit  :
    {
        defaultValue : item =>
        {
            if( item )
            {
                const { activities } = item ;
                if( activities instanceof Array )
                {
                    return activities.map( element =>
                    {
                        if( element instanceof Word )
                        {
                            return element.clone() ;
                        }
                        return null ;
                    })
                }
            }
            return null ;
        },
        prepare : ( datas ) =>
        {
            if( datas instanceof Array )
            {
                datas = datas.map( item => item instanceof Word ? item.id : null ) ;
                let object = datas.join(',');
                object = { activities : object  } ;
                //console.log( 'prepare' , object );
                return object;
            }
            return null ;
        },
        agree       : 'Enregistrer' ,
        description : 'Sélectionner des activités dans la liste ci-dessous.',
        disagree    : 'Annuler' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en cours...',
        refresh     : 'Charger',
        success     : 'Mise à jour réussie!' ,
        title       : 'Activités' ,
        uri         : api.thesaurus.activities,
        type        : dialogType.THESAURUS_CHECKER

    },
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Modifier" ,
        remove : "Supprimer"
    }
};

export default activities ;
